import React, { Component } from 'react';
import { Link } from "react-router-dom";
import UserDropdown from "./UserDropdown";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import track from "../lib/tracking";
import Header from "./Header";
import HomeHeader from "./HomeHeader";

class PageWrapper extends Component {
  
  getHeader = () => {
    return this.props.page === "home" ? 
      <HomeHeader authed={this.props.authed} logout={this.props.logout} setRedirect={this.props.setRedirect}/> : 
      <Header authed={this.props.authed} logout={this.props.logout} setRedirect={this.props.setRedirect}/>;
  };

  render() {
    return (
      <div>
        { this.getHeader() }
        <div className="page" > {this.props.children} </div>
      </div>
    );

  }
}

export default PageWrapper;



// WEBPACK FOOTER //
// ./src/components/PageWrapper.js